import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import type { StoragePayload } from '@/store/types/StoragePayload'

export const useExternalStorageStore = defineStore('externalStorage', () => {
  const storages = ref<StoragePayload[]>([])

  const storagesDefaultFirst = computed(() => {
    const defaultStorage = storages.value.find((s) => s.default === true)
    return defaultStorage
      ? [defaultStorage, ...storages.value.filter((s) => s && s.slug !== defaultStorage.slug)]
      : storages.value
  })

  return {
    storages,
    storagesDefaultFirst,
  }
})
